// import { useGetTrade } from '@/hooks/useGetTrade';

import { FeedSSE } from '@/sse/trade';
import { useAddress } from '@/store/selector';
import { useTradeStore } from '@/store/trade-store';
import { useEffect } from 'react';
import { useFeedStore } from './feed/useFeedStore';

export default function SubscribeTrade() {
    // useGetTrade();
    const address = useAddress();

    const [setBookingData, setOrderTradeData, setPendingOrder] = useTradeStore(
        (state) => {
            return [
                state.setBookingData,
                state.setOrderTradeData,
                state.setPendingOrder,
            ];
        }
    );

    const addNewFeed = useFeedStore((state) => state.addNewFeed);

    useEffect(() => {
        if (address) {
            FeedSSE.getInstance().setAddress(address);
            FeedSSE.getInstance().on('pair_params', (data) => {
                // console.log('pair_params', data);
                setBookingData(data);
            });
            FeedSSE.getInstance().on('trades', (data) => {
                // console.log('trades', data);
                setOrderTradeData(data);
            });
            FeedSSE.getInstance().on('feed', (data) => {
                // console.log('feed', data);v
                addNewFeed(data)
            });

             FeedSSE.getInstance().on('pending_orders', (data) => {
                // console.log('feed', data);v
                setPendingOrder(data)
            });
        }

        return () => {
            FeedSSE.getInstance().close();
        };
    }, [address]);

    return null;
}
